<style scoped lang="scss">
.development-content-div {
    background-color: rgb(242 242 242) !important;
    font-size: 1rem;
}

.not-developer-praent {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.not-developer-div {
    padding: 1rem;
    width: fit-content;
    background-color: white;
    border-radius: 5px;
}




.includes_table {
    width: fit-content;
}

.price_table td,
.price_table th,
.agentPrice_table td,
.agentPrice_table th {
    padding: 1rem;
    font-size: 1rem;
    text-align: center;
}

@media screen and (min-width: 768px) {
    .deveploer-content {
        width: fit-content;
        padding: 1rem;
        margin-left: 2rem;
        margin-top: 2rem;
        background-color: white;
    }

    .data-table {
        max-width: 70vw;
    }

    .development-content-div {
        padding: 1rem;
        padding-bottom: 5rem;
    }
}

@media screen and (max-width: 769px) {
    .deveploer-content {
        width: fit-content;
        padding: 1rem;
        margin-left: 1rem;
        margin-top: 1rem;
        background-color: white;
    }

    .data-table {
        width: fit-content;
    }

    .development-content-div {
        min-width: fit-content;
        padding-bottom: 5rem;
    }
}
</style>
<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;padding-left: 0;background-color: rgb(242, 242, 242) !important;overflow: auto;height:100vh;">
                    <div class="development-content-div">
                        <div v-if="isDeveloper == 0" class="not-developer-praent">
                            <div class="not-developer-div">
                                <p style="font-size: 1rem;">您还不是开发者，暂时无法查看本页面喔~</p>
                                <div
                                    style="text-align: center; width: fit-content;margin: 3rem auto 0.5rem;font-size: 1rem;">
                                    <el-button type="primary" @click="goApiUrl">
                                        成为开发者
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <div v-if="isDeveloper == 1" class="d-flex flex-column deveploer-content rounded shadow">
                            <el-table :data="includesList" class="includes_table">
                                <el-table-column prop="id" label="插件id" width="80" />
                                <el-table-column prop="name" label="插件名" width="170">
                                    <template v-slot="scope">
                                        <el-input v-model="scope.row.name" style="width: 140px"
                                            maxlength="8"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="include_desc" label="插件介绍" width="250">
                                    <template v-slot="scope">
                                        <el-input v-model="scope.row.include_desc" maxlength="150" style="width: 240px"
                                            placeholder="Please input" show-word-limit type="textarea" rows="3" />
                                    </template>
                                </el-table-column>
                                <el-table-column label="授权价格" width="150">
                                    <template v-slot="scope">
                                        <el-button type="success" @click="getPrice(scope.row.id)">查看/修改</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column label="代理价格" width="150">
                                    <template v-slot="scope">
                                        <el-button type="success" @click="getAgentPrice(scope.row.id)">查看/修改</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column label="支持泛域名" width="120">
                                    <template v-slot="scope">
                                        <el-radio-group v-model="scope.row.is_Whole">
                                            <el-radio :value="1" size="large" class="liu-text-success">支持</el-radio>
                                            <el-radio :value="0" size="large" class="liu-text-danger">不支持</el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>
                                <el-table-column label="插件类型" width="100">
                                    <template v-slot="scope">
                                        <el-radio-group v-model="scope.row.is_Share">
                                            <el-radio :value="1" size="large" class="liu-text-success">通用插件</el-radio>
                                            <el-radio :value="0" size="large" class="liu-text-warning">独立插件</el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>
                                <el-table-column label="保存" width="120">
                                    <template v-slot="scope">
                                        <el-button type="primary" @click="saveIncludes(scope.row)">保存</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <el-dialog :close-on-click-modal="false" v-model="centerDialog.isShow" title="授权价格查看/修改" width="800"
                        align-center>
                        <div>
                            <!-- Version Tabs (similar to IncludesList.vue) -->
                            <div v-if="Object.keys(price_meal.versions).length > 1" class="version-tabs-container">
                                <el-tabs v-model="price_meal.active_version">
                                    <el-tab-pane v-for="(version_data, version_key) in price_meal.versions"
                                        :key="version_key" :label="version_data.name" :name="parseInt(version_key)">
                                    </el-tab-pane>
                                </el-tabs>
                            </div>

                            <!-- Version Description -->
                            <div v-if="price_meal.versions[price_meal.active_version] && price_meal.versions[price_meal.active_version].desc"
                                class="version-description">
                                {{ price_meal.versions[price_meal.active_version].desc }}
                            </div>

                            <el-link
                                @click="addPriceDialogFun(getActivePriceMeal()[0]?.grade_conf.includes_id, price_meal.active_version)"
                                type="primary">新增价格规则</el-link>

                            <table class="table price_table">
                                <thead class="table-thead">
                                    <tr
                                        v-if="getActivePriceMeal().length > 0 && getActivePriceMeal()[0].time_price.length > 0">
                                        <th>用户类型</th>
                                        <th v-for="item in getActivePriceMeal()[0].time_price" :key="item.meal_id">
                                            {{ item.time_unit }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-if="getActivePriceMeal().length == 0 || getActivePriceMeal()[0].time_price.length == 0">
                                        <td colspan="3">--暂无价格套餐--</td>
                                    </tr>
                                    <tr v-else v-for="(row, rowI) in getActivePriceMeal()" :key="rowI">
                                        <th>{{ row.grade_conf.grade_name }}</th>
                                        <td v-for="(item, i) in row.time_price" :key="i">
                                            <el-input style="width: 4.4rem;" v-model="item.price"
                                                @change="updatePrice(item.meal_price_id, item.price, price_meal.active_version)"></el-input>
                                        </td>
                                    </tr>
                                    <!-- Delete buttons at the bottom of each column -->
                                    <tr
                                        v-if="getActivePriceMeal().length > 0 && getActivePriceMeal()[0].time_price.length > 0">
                                        <th>操作</th>
                                        <td v-for="(item, i) in getActivePriceMeal()[0].time_price" :key="i">
                                            <el-button type="danger" size="small"
                                                @click="deletePriceDialog(item.meal_id, item.includes_id, price_meal.active_version)">
                                                删除
                                            </el-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="getActivePriceMeal().length > 0 && getActivePriceMeal()[0].time_price.length > 0"
                                class="liu-text-info liu-div-center ml-4">
                                ---您可以修改相关价格---
                            </div>
                        </div>
                        <template #footer>
                            <div class="dialog-footer">
                                <el-button @click="centerDialog.isShow = false">关闭</el-button>
                            </div>
                        </template>
                    </el-dialog>
                    <el-dialog :close-on-click-modal="false" v-model="agentDialog.isShow" title="代理价格查看/修改" width="1000"
                        align-center>
                        <div>
                            <table class="table agentPrice_table">
                                <thead class="table-thead">
                                    <tr>
                                        <td>代理名称</td>
                                        <td>等级</td>
                                        <td>开通价格</td>
                                        <td>可开下级</td>
                                        <td>下级升级返利</td>
                                        <td>操作</td>
                                    </tr>
                                </thead>
                                <tr v-for="(item, i) in agentPrice" :key="i">
                                    <td>
                                        <el-input style="width: 6.4rem;" v-model="item.grade_name"
                                            maxlength="10"></el-input>
                                    </td>
                                    <td>{{ item.grade }}</td>
                                    <td>
                                        <div style="display: flex;flex-direction: row;align-items: center;">
                                            <el-input style="width: 3.4rem;" v-model="item.price"></el-input>元
                                        </div>
                                    </td>
                                    <td>
                                        <el-radio-group v-model="item.open_lower_agent">
                                            <el-radio :value="1" size="large" class="liu-text-success">支持</el-radio>
                                            <el-radio :value="0" size="large" class="liu-text-danger">不支持</el-radio>
                                        </el-radio-group>
                                    </td>
                                    <td>
                                        <div>
                                            <el-input style="width: 2.8rem;" v-model="item.rebate_ratio"></el-input>%
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <el-button type="primary" @click="saveAgent(item)">保存</el-button>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <div class="liu-text-info liu-div-center ml-4">---您可以修改相关价格---</div>
                        </div>
                        <template #footer>
                            <div class="dialog-footer">
                                <el-button @click="agentDialog.isShow = false">关闭</el-button>
                            </div>
                        </template>
                    </el-dialog>
                    <el-dialog :close-on-click-modal="false" v-model="addPriceDialog.isShow" title="新增授权价格" width="800"
                        align-center>
                        <div>
                            <table class="table agentPrice_table">
                                <thead class="table-thead">
                                    <tr v-for="(item, i) in addPriceDialog.timeList" :key="i">
                                        <th>{{ item.time_unit }}：</th>
                                        <td v-for="(grade, i2) in addPriceDialog.gradeList" :key="i2">
                                            <div>
                                                {{ grade.gradeName }}
                                                <el-input style="width: 4.4rem;"
                                                    v-model="addPriceDialog.gradeTimePrice[i].gradeList[i2].price"></el-input>元
                                            </div>
                                        </td>
                                        <td><el-button type="success"
                                                @click="addPriceFun(addPriceDialog.gradeTimePrice[i])">新增</el-button>
                                        </td>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <template #footer>
                            <div class="dialog-footer">
                                <el-button @click="addPriceDialog.isShow = false">关闭</el-button>
                            </div>
                        </template>
                    </el-dialog>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isLogin, isNull, compareDates, openBox } from "@/utils/publicMethods"
import { ElMessage, ElNotification, ElMessageBox } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { data } from 'jquery';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            isDeveloper: 2,
            deveploerConf: {
                apiUrl: ""
            },
            includesList: "",
            centerDialog: {
                isShow: false,
            },
            price_meal: {
                versions: {}, // Store different versions
                active_version: 1 // Track active version
            },
            agentDialog: {
                isShow: false
            },
            agentPrice: [],
            addPriceDialog: {
                isShow: false,
                timeList: [],
                gradeList: [],
                gradeTimePrice: []
            },

        }
    },
    methods: {
        goApiUrl() {
            location.href = this.deveploerConf.apiUrl;
        },
        getIncludes() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/dev/getIncludes', { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.includesList = res.data.data;
                        this.drawEveryDayData();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    // ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        saveIncludes(row) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/dev/updateIncludes', JSON.stringify(row), { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success(res.data.msg)
                        this.isDeveloper = 1;
                        this.includesList = res.data.data;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        }, getActivePriceMeal() {
            const activeVersion = this.price_meal.active_version;
            if (this.price_meal.versions[activeVersion]) {
                return this.price_meal.versions[activeVersion].meals;
            }
            return [];
        },
        getPrice(id) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            var data = new FormData()
            data.append("includes_id", id.toString())
            axios.post(baseURL + "/userApi/getGradeTimeMeal", data, { timeout: 30000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 200) {
                        const versions_data = res.data.data.data;

                        // Reset price_meal object
                        this.price_meal = {
                            versions: {},
                            active_version: 1
                        };

                        // Process each version
                        versions_data.forEach((version_item, index) => {
                            const version_name = version_item.version_name || `版本 ${index + 1}`;
                            const version_key = version_item.version;

                            // Store data for this version
                            this.price_meal.versions[version_key] = {
                                name: version_name,
                                desc: version_item.version_desc || '',
                                meals: []
                            };

                            // Process grade_arr for this version
                            version_item.grade_arr.forEach(grade_item => {
                                this.price_meal.versions[version_key].meals.push({
                                    grade_conf: grade_item.grade_conf,
                                    time_price: grade_item.time_price.slice().sort((a, b) => {
                                        return a.meal_id - b.meal_id;
                                    }),
                                })
                            });

                            // Sort meals by grade
                            this.price_meal.versions[version_key].meals.sort((a, b) => {
                                return a.grade_conf.grade - b.grade_conf.grade;
                            });
                        });
                        console.log(this.price_meal);


                        this.centerDialog.isShow = true
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    ElMessage.error('获取价格表失败：' + err.message)
                })
        },
        getAgentPrice(id) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + "/dev/getGradePrice?includesId=" + id, { timeout: 30000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 200) {
                        var agentPrice = res.data.data
                        agentPrice.slice().sort(function (a, b) {
                            return a.grade - b.grade;
                        })
                        this.agentPrice = agentPrice;
                        this.agentDialog.isShow = true
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    ElMessage.error('获取价格表失败：' + err.message)
                })
        },
        updatePrice(id, price) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            let data = {
                mealPriceId: id,
                price: price
            }
            axios.post(baseURL + '/dev/updateTimePrice', JSON.stringify(data), { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success(res.data.msg)

                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        saveAgent(agentData) {
            console.log(JSON.stringify(agentData));
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/dev/saveAgentConf', JSON.stringify(agentData), { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success(res.data.msg)

                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        addPriceDialogFun(id, version = 0) {
            this.addPriceDialog.isShow = true;
            this.addPriceDialog.version = version; // Store version
            // console.log(JSON.stringify(agentData));
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.get(baseURL + '/dev/getCanAddTimeMeal?includesId=' + id+"&version="+version, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        let timeList = res.data.data.timeList;
                        let gradeList = res.data.data.gradeList;
                        if (timeList.length == 0) {
                            ElMessage.error("已经没有可添加的时间套餐")
                            this.addPriceDialog.isShow = false;
                            return;
                        }
                        this.addPriceDialog.timeList = timeList;
                        this.addPriceDialog.gradeList = gradeList;
                        let gradeTimePriceTemp = [];
                        for (let i = 0; i < timeList.length; i++) {
                            const timeItem = timeList[i];
                            let timeTemp = {
                                mealId: timeItem.meal_id,
                                includesId: id,
                                gradeList: []
                            }
                            for (let j = 0; j < gradeList.length; j++) {
                                const gradeItem = gradeList[j];
                                let gradeTemp = {
                                    // timeId: timeItem.id,
                                    grade: gradeItem.grade,
                                    price: 0
                                }
                                timeTemp.gradeList.push(gradeTemp);
                            }
                            gradeTimePriceTemp.push(timeTemp);
                        }
                        this.addPriceDialog.gradeTimePrice = gradeTimePriceTemp;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        addPriceFun(data) {
            data.version = this.addPriceDialog.version;
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/dev/addTimePrice', JSON.stringify(data), { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success(res.data.msg)
                        this.addPriceDialog.isShow = false;
                        this.getPrice(data.includesId);
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })

        },
        deletePriceDialog(meal_id, includes_id) {
            ElMessageBox.confirm(
                '确定删除该套餐？该操作无法撤销！',
                'Warning',
                {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    this.deletePrice(meal_id, includes_id)
                })
                .catch(() => {
                    console.log();

                })
        },
        deletePrice(meal_id, includes_id) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.get(baseURL + '/dev/deleteTimePrice?mealId=' + meal_id + '&IncludesId=' + includes_id+"&version="+this.price_meal.active_version, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success(res.data.msg)
                        this.getPrice(includes_id);
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })

        },
        isNull(text) {
            return isNull(text);
        }
    },
    mounted() {
        this.getIncludes()
    }
})
</script>
